import { filterDiffFunction, orderArray, getArrayNumberChanges } from './chunk-WTGT4IDV.mjs';
import { selectCurrentSettingsOriginalData, selectCurrentSettingsData, selectDashboards } from './chunk-67X7HZEW.mjs';
import { i18n_config_default } from './chunk-EJ2TIXJU.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';
import { startCase } from 'lodash';
import camelCase from 'lodash/camelCase';

var BasicFieldLabels = /* @__PURE__ */ ((BasicFieldLabels2) => {
  BasicFieldLabels2[BasicFieldLabels2["active"] = 0] = "active";
  BasicFieldLabels2[BasicFieldLabels2["name"] = 1] = "name";
  BasicFieldLabels2[BasicFieldLabels2["posName"] = 2] = "posName";
  BasicFieldLabels2[BasicFieldLabels2["backgroundColor"] = 3] = "backgroundColor";
  BasicFieldLabels2[BasicFieldLabels2["textColor"] = 4] = "textColor";
  return BasicFieldLabels2;
})(BasicFieldLabels || {});
var HomeFieldLabels = /* @__PURE__ */ ((HomeFieldLabels2) => {
  HomeFieldLabels2[HomeFieldLabels2["registerModuleDefault"] = 0] = "registerModuleDefault";
  HomeFieldLabels2[HomeFieldLabels2["menuModuleDefault"] = 1] = "menuModuleDefault";
  HomeFieldLabels2[HomeFieldLabels2["settingsModuleDefault"] = 2] = "settingsModuleDefault";
  HomeFieldLabels2[HomeFieldLabels2["managementModuleDefault"] = 3] = "managementModuleDefault";
  HomeFieldLabels2[HomeFieldLabels2["reportsModuleDefault"] = 4] = "reportsModuleDefault";
  HomeFieldLabels2[HomeFieldLabels2["customersModuleDefault"] = 5] = "customersModuleDefault";
  HomeFieldLabels2[HomeFieldLabels2["requireClockInOnPrompt"] = 6] = "requireClockInOnPrompt";
  HomeFieldLabels2[HomeFieldLabels2["defaultModule"] = 7] = "defaultModule";
  return HomeFieldLabels2;
})(HomeFieldLabels || {});
var EndOfDayFieldLabels = /* @__PURE__ */ ((EndOfDayFieldLabels2) => {
  EndOfDayFieldLabels2[EndOfDayFieldLabels2["viewShiftSummary"] = 0] = "viewShiftSummary";
  return EndOfDayFieldLabels2;
})(EndOfDayFieldLabels || {});
var WebHomeScreenFieldLabels = /* @__PURE__ */ ((WebHomeScreenFieldLabels2) => {
  WebHomeScreenFieldLabels2[WebHomeScreenFieldLabels2["dashboardIds"] = 0] = "dashboardIds";
  WebHomeScreenFieldLabels2[WebHomeScreenFieldLabels2["defaultDashboardId"] = 1] = "defaultDashboardId";
  return WebHomeScreenFieldLabels2;
})(WebHomeScreenFieldLabels || {});
var RegisterFieldLabels = /* @__PURE__ */ ((RegisterFieldLabels2) => {
  RegisterFieldLabels2[RegisterFieldLabels2["registerModuleAvailable"] = 0] = "registerModuleAvailable";
  RegisterFieldLabels2[RegisterFieldLabels2["createOrders"] = 1] = "createOrders";
  RegisterFieldLabels2[RegisterFieldLabels2["deleteOrders"] = 2] = "deleteOrders";
  RegisterFieldLabels2[RegisterFieldLabels2["modifyItemsSentToKitchen"] = 3] = "modifyItemsSentToKitchen";
  RegisterFieldLabels2[RegisterFieldLabels2["editOtherUsersOrders"] = 4] = "editOtherUsersOrders";
  RegisterFieldLabels2[RegisterFieldLabels2["transferOrderOwner"] = 5] = "transferOrderOwner";
  RegisterFieldLabels2[RegisterFieldLabels2["manageTables"] = 6] = "manageTables";
  RegisterFieldLabels2[RegisterFieldLabels2["addAnyDiscount"] = 7] = "addAnyDiscount";
  RegisterFieldLabels2[RegisterFieldLabels2["addCustomDiscount"] = 8] = "addCustomDiscount";
  RegisterFieldLabels2[RegisterFieldLabels2["overrideLicenseEditingId"] = 9] = "overrideLicenseEditingId";
  RegisterFieldLabels2[RegisterFieldLabels2["reprint"] = 10] = "reprint";
  RegisterFieldLabels2[RegisterFieldLabels2["deletePrintJobs"] = 11] = "deletePrintJobs";
  RegisterFieldLabels2[RegisterFieldLabels2["printEndOfShiftReportOnClockOut"] = 12] = "printEndOfShiftReportOnClockOut";
  RegisterFieldLabels2[RegisterFieldLabels2["allowChangeMenuType"] = 13] = "allowChangeMenuType";
  RegisterFieldLabels2[RegisterFieldLabels2["editItemPrice"] = 14] = "editItemPrice";
  RegisterFieldLabels2[RegisterFieldLabels2["allow86"] = 15] = "allow86";
  RegisterFieldLabels2[RegisterFieldLabels2["behaviorOnNewOrder"] = 16] = "behaviorOnNewOrder";
  RegisterFieldLabels2[RegisterFieldLabels2["createChecks"] = 17] = "createChecks";
  RegisterFieldLabels2[RegisterFieldLabels2["voidRefundPayments"] = 18] = "voidRefundPayments";
  RegisterFieldLabels2[RegisterFieldLabels2["createPayments"] = 19] = "createPayments";
  RegisterFieldLabels2[RegisterFieldLabels2["batch"] = 20] = "batch";
  RegisterFieldLabels2[RegisterFieldLabels2["manageDrawers"] = 21] = "manageDrawers";
  RegisterFieldLabels2[RegisterFieldLabels2["reopenClosedOrders"] = 22] = "reopenClosedOrders";
  RegisterFieldLabels2[RegisterFieldLabels2["transferPayments"] = 23] = "transferPayments";
  RegisterFieldLabels2[RegisterFieldLabels2["viewDrawerBalance"] = 24] = "viewDrawerBalance";
  RegisterFieldLabels2[RegisterFieldLabels2["serverBankEnabled"] = 25] = "serverBankEnabled";
  RegisterFieldLabels2[RegisterFieldLabels2["allowCashPaymentsToDrawersNotAttached"] = 26] = "allowCashPaymentsToDrawersNotAttached";
  RegisterFieldLabels2[RegisterFieldLabels2["createOpenItemsOrModItems"] = 27] = "createOpenItemsOrModItems";
  RegisterFieldLabels2[RegisterFieldLabels2["allowNoTaxInclusive"] = 28] = "allowNoTaxInclusive";
  RegisterFieldLabels2[RegisterFieldLabels2["exemptTax"] = 29] = "exemptTax";
  RegisterFieldLabels2[RegisterFieldLabels2["manageServiceCharges"] = 30] = "manageServiceCharges";
  RegisterFieldLabels2[RegisterFieldLabels2["showMenuSelector"] = 31] = "showMenuSelector";
  RegisterFieldLabels2[RegisterFieldLabels2["qsrActionOnPay"] = 32] = "qsrActionOnPay";
  RegisterFieldLabels2[RegisterFieldLabels2["navigationActionOnSendButton"] = 33] = "navigationActionOnSendButton";
  RegisterFieldLabels2[RegisterFieldLabels2["navigationActionOnDoneButton"] = 34] = "navigationActionOnDoneButton";
  RegisterFieldLabels2[RegisterFieldLabels2["navigationActionOnSendStayButton"] = 35] = "navigationActionOnSendStayButton";
  RegisterFieldLabels2[RegisterFieldLabels2["defaultRegisterScreen"] = 36] = "defaultRegisterScreen";
  RegisterFieldLabels2[RegisterFieldLabels2["voidIndividualItems"] = 37] = "voidIndividualItems";
  RegisterFieldLabels2[RegisterFieldLabels2["sendIndividualItems"] = 38] = "sendIndividualItems";
  RegisterFieldLabels2[RegisterFieldLabels2["makeHouseChargePayments"] = 39] = "makeHouseChargePayments";
  RegisterFieldLabels2[RegisterFieldLabels2["makeGiftCardPayments"] = 40] = "makeGiftCardPayments";
  RegisterFieldLabels2[RegisterFieldLabels2["navigationActionOnCloseOrder"] = 41] = "navigationActionOnCloseOrder";
  RegisterFieldLabels2[RegisterFieldLabels2["navigationActionOnTipPending"] = 42] = "navigationActionOnTipPending";
  RegisterFieldLabels2[RegisterFieldLabels2["navigationActionOnPrintChecks"] = 43] = "navigationActionOnPrintChecks";
  RegisterFieldLabels2[RegisterFieldLabels2["navigationActionOnFire"] = 44] = "navigationActionOnFire";
  RegisterFieldLabels2[RegisterFieldLabels2["defaultOrderType"] = 45] = "defaultOrderType";
  RegisterFieldLabels2[RegisterFieldLabels2["autoFilterTableTabsOrders"] = 46] = "autoFilterTableTabsOrders";
  RegisterFieldLabels2[RegisterFieldLabels2["viewPrinterCenter"] = 47] = "viewPrinterCenter";
  RegisterFieldLabels2[RegisterFieldLabels2["changePrinterStatus"] = 48] = "changePrinterStatus";
  RegisterFieldLabels2[RegisterFieldLabels2["transferPrintJobs"] = 49] = "transferPrintJobs";
  RegisterFieldLabels2[RegisterFieldLabels2["reAssignBackupPrinter"] = 50] = "reAssignBackupPrinter";
  RegisterFieldLabels2[RegisterFieldLabels2["reprintClosedCheck"] = 51] = "reprintClosedCheck";
  RegisterFieldLabels2[RegisterFieldLabels2["reprintReceipt"] = 52] = "reprintReceipt";
  RegisterFieldLabels2[RegisterFieldLabels2["refundTypeRefund"] = 53] = "refundTypeRefund";
  RegisterFieldLabels2[RegisterFieldLabels2["refundTypeAsDiscount"] = 54] = "refundTypeAsDiscount";
  RegisterFieldLabels2[RegisterFieldLabels2["refundTypeToBalanceDueOfZero"] = 55] = "refundTypeToBalanceDueOfZero";
  RegisterFieldLabels2[RegisterFieldLabels2["refundTypeReplacePayment"] = 56] = "refundTypeReplacePayment";
  RegisterFieldLabels2[RegisterFieldLabels2["cashPaymentOptions"] = 57] = "cashPaymentOptions";
  return RegisterFieldLabels2;
})(RegisterFieldLabels || {});
var MenuFieldLabels = /* @__PURE__ */ ((MenuFieldLabels2) => {
  MenuFieldLabels2[MenuFieldLabels2["menuModuleAvailable"] = 0] = "menuModuleAvailable";
  MenuFieldLabels2[MenuFieldLabels2["accessMasterMenu"] = 1] = "accessMasterMenu";
  MenuFieldLabels2[MenuFieldLabels2["massUpdate"] = 2] = "massUpdate";
  return MenuFieldLabels2;
})(MenuFieldLabels || {});
var SettingsFieldLabels = /* @__PURE__ */ ((SettingsFieldLabels2) => {
  SettingsFieldLabels2[SettingsFieldLabels2["settingsModuleAvailable"] = 0] = "settingsModuleAvailable";
  SettingsFieldLabels2[SettingsFieldLabels2["accessMasterSettings"] = 1] = "accessMasterSettings";
  return SettingsFieldLabels2;
})(SettingsFieldLabels || {});
var ManagementFieldLabels = /* @__PURE__ */ ((ManagementFieldLabels2) => {
  ManagementFieldLabels2[ManagementFieldLabels2["managementModuleAvailable"] = 0] = "managementModuleAvailable";
  return ManagementFieldLabels2;
})(ManagementFieldLabels || {});
var ReportsFieldLabels = /* @__PURE__ */ ((ReportsFieldLabels2) => {
  ReportsFieldLabels2[ReportsFieldLabels2["reportsModuleAvailable"] = 0] = "reportsModuleAvailable";
  return ReportsFieldLabels2;
})(ReportsFieldLabels || {});
var CustomersFieldLabels = /* @__PURE__ */ ((CustomersFieldLabels2) => {
  CustomersFieldLabels2[CustomersFieldLabels2["customersModuleAvailable"] = 0] = "customersModuleAvailable";
  return CustomersFieldLabels2;
})(CustomersFieldLabels || {});
var HOME_SCREEN_PERMISSIONS_FIELD = "homeScreenPermissions";
var MENU_SCREEN_PERMISSIONS_FIELD = "menuPermissions";
var SETTINGS_SCREEN_PERMISSIONS_FIELD = "settingsPermissions";
var returnLabel = (field) => {
  if (field in BasicFieldLabels) {
    return i18n_config_default.t(
      `app.modals.rolesDiffModal.basic.${field}`
    );
  }
  if (field in HomeFieldLabels) {
    return i18n_config_default.t(
      `app.modals.rolesDiffModal.home.${field}`
    );
  }
  if (field in RegisterFieldLabels) {
    return i18n_config_default.t(
      `app.modals.rolesDiffModal.register.${field}`
    );
  }
  if (field in MenuFieldLabels) {
    return i18n_config_default.t(
      `app.modals.rolesDiffModal.menu.${field}`
    );
  }
  if (field in SettingsFieldLabels) {
    return i18n_config_default.t(
      `app.modals.rolesDiffModal.settings.${field}`
    );
  }
  if (field in ManagementFieldLabels) {
    return i18n_config_default.t(
      `app.modals.rolesDiffModal.management.${field}`
    );
  }
  if (field in ReportsFieldLabels) {
    return i18n_config_default.t(
      `app.modals.rolesDiffModal.reports.${field}`
    );
  }
  if (field in CustomersFieldLabels) {
    return i18n_config_default.t(
      `app.modals.rolesDiffModal.customers.${field}`
    );
  }
  if (field in EndOfDayFieldLabels) {
    return i18n_config_default.t(
      `app.modals.rolesDiffModal.endOfDay.${field}`
    );
  }
  if (field in WebHomeScreenFieldLabels) {
    return i18n_config_default.t(
      `app.modals.rolesDiffModal.webHomeScreen.${field}`
    );
  }
};
var diffRolesFactory = (diffArray, state) => {
  if (diffArray.length > 0) {
    const basic = generateBasicArray(diffArray);
    const home = generateHomeArray(diffArray);
    const endOfDay = generateEndOfDayArray(diffArray);
    const register = generateRegisterArray(diffArray);
    const menu = generateMenuArray(diffArray);
    const settings = generateSettingsArray(diffArray);
    const management = generateManagementArray(diffArray);
    const reports = generateReportsArray(diffArray);
    const customers = generateCustomersArray(diffArray);
    const webHomeScreen = generateWebHomeScreenArray(diffArray, state);
    return {
      basic,
      home,
      endOfDay,
      register,
      menu,
      settings,
      management,
      reports,
      customers,
      webHomeScreen
    };
  }
  return null;
};
var generateBasicArray = (diffArray) => {
  const basic = [];
  diffArray.forEach(
    (diff) => filterDiffFunction(
      diff,
      ({ field, diffLength, newDiff }) => {
        if (diffLength !== 1) {
          return;
        }
        if (field in BasicFieldLabels && isNaN(Number(field))) {
          basic.push(newDiff);
        }
      },
      returnLabel
    )
  );
  return orderArray(basic, BasicFieldLabels);
};
var generateHomeArray = (diffArray) => {
  const home = [];
  diffArray.forEach(
    (diff) => filterDiffFunction(
      diff,
      ({ field, diffLength, newDiff }) => {
        if (diffLength === 1 && field in HomeFieldLabels && isNaN(Number(field))) {
          if (field === "defaultModule") {
            return home.push(__spreadProps(__spreadValues({}, newDiff), {
              textValue: i18n_config_default.t(
                `settingsModule.roleDetailsSettings.home.homeScreenDefaultModules.modules.${newDiff.value}Default`
              )
            }));
          }
          return home.push(newDiff);
        }
        if (diffLength !== 2) {
          return;
        }
        if (field in HomeFieldLabels && isNaN(Number(field))) {
          home.push(newDiff);
        }
      },
      returnLabel
    )
  );
  return orderArray(home, HomeFieldLabels);
};
var generateEndOfDayArray = (diffArray) => {
  const endOfDay = [];
  diffArray.forEach(
    (diff) => filterDiffFunction(
      diff,
      ({ field, diffLength, newDiff }) => {
        if (diffLength !== 2) {
          return;
        }
        if (field in EndOfDayFieldLabels && isNaN(Number(field))) {
          const textValue = i18n_config_default.t(
            `settingsModule.roleDetailsSettings.endOfDay.endOfDayPermissions.viewShiftSummary.options.${newDiff.value}`
          );
          endOfDay.push(__spreadProps(__spreadValues({}, newDiff), { textValue }));
        }
      },
      returnLabel
    )
  );
  return orderArray(endOfDay, EndOfDayFieldLabels);
};
var generateRegisterArray = (diffArray) => {
  const register = [];
  const REGISTER_PERMISSIONS_FIELD = "registerPermissions";
  diffArray.forEach(
    (diff) => filterDiffFunction(
      diff,
      ({ field, diffLength, newDiff }) => {
        if (diffLength !== 2) {
          return;
        }
        const parentField = diff.path[0];
        if (![REGISTER_PERMISSIONS_FIELD, HOME_SCREEN_PERMISSIONS_FIELD].includes(
          parentField
        )) {
          return;
        }
        if (field === "behaviorOnNewOrder") {
          return register.push(__spreadProps(__spreadValues({}, newDiff), {
            textValue: i18n_config_default.t(
              `settingsModule.roleDetailsSettings.register.behaviorOnNewOrder.options.${newDiff.value}`
            )
          }));
        }
        if (field === "qsrActionOnPay") {
          return register.push(__spreadProps(__spreadValues({}, newDiff), {
            textValue: startCase(`${newDiff.value}`)
          }));
        }
        if (field === "defaultOrderType") {
          return register.push(__spreadProps(__spreadValues({}, newDiff), {
            textValue: startCase(`${newDiff.value}`)
          }));
        }
        if (field in RegisterFieldLabels && isNaN(Number(field))) {
          if (field === "cashPaymentOptions") {
            return register.push(__spreadProps(__spreadValues({}, newDiff), {
              textValue: newDiff.value ? i18n_config_default.t(
                `settingsModule.roleDetailsSettings.register.drawers.cashPaymentOptions.options.${camelCase(newDiff.value)}`
              ) : i18n_config_default.t("commonTexts.all")
            }));
          }
          register.push(newDiff);
        }
      },
      returnLabel
    )
  );
  return orderArray(register, RegisterFieldLabels);
};
var generateMenuArray = (diffArray) => {
  const menu = [];
  diffArray.forEach(
    (diff) => filterDiffFunction(
      diff,
      ({ field, diffLength, newDiff }) => {
        if (diffLength !== 2) {
          return;
        }
        const parentField = diff.path[0];
        if (![
          HOME_SCREEN_PERMISSIONS_FIELD,
          MENU_SCREEN_PERMISSIONS_FIELD
        ].includes(parentField)) {
          return;
        }
        if (field in MenuFieldLabels && isNaN(Number(field))) {
          menu.push(newDiff);
        }
      },
      returnLabel
    )
  );
  return orderArray(menu, MenuFieldLabels);
};
var generateSettingsArray = (diffArray) => {
  const settings = [];
  diffArray.forEach(
    (diff) => filterDiffFunction(
      diff,
      ({ field, diffLength, newDiff }) => {
        if (diffLength !== 2) {
          return;
        }
        const parentField = diff.path[0];
        if (![
          HOME_SCREEN_PERMISSIONS_FIELD,
          SETTINGS_SCREEN_PERMISSIONS_FIELD
        ].includes(parentField)) {
          return;
        }
        if (field in SettingsFieldLabels && isNaN(Number(field))) {
          settings.push(newDiff);
        }
      },
      returnLabel
    )
  );
  return orderArray(settings, SettingsFieldLabels);
};
var generateManagementArray = (diffArray) => {
  const management = [];
  diffArray.forEach(
    (diff) => filterDiffFunction(
      diff,
      ({ field, diffLength, newDiff }) => {
        if (diffLength !== 2) {
          return;
        }
        const parentField = diff.path[0];
        if (parentField !== HOME_SCREEN_PERMISSIONS_FIELD) {
          return;
        }
        if (field in ManagementFieldLabels && isNaN(Number(field))) {
          management.push(newDiff);
        }
      },
      returnLabel
    )
  );
  return orderArray(management, ManagementFieldLabels);
};
var generateReportsArray = (diffArray) => {
  const reports = [];
  diffArray.forEach(
    (diff) => filterDiffFunction(
      diff,
      ({ field, diffLength, newDiff }) => {
        if (diffLength !== 2) {
          return;
        }
        const parentField = diff.path[0];
        if (parentField !== HOME_SCREEN_PERMISSIONS_FIELD) {
          return;
        }
        if (field in ReportsFieldLabels && isNaN(Number(field))) {
          reports.push(newDiff);
        }
      },
      returnLabel
    )
  );
  return orderArray(reports, ReportsFieldLabels);
};
var generateCustomersArray = (diffArray) => {
  const reports = [];
  diffArray.forEach(
    (diff) => filterDiffFunction(
      diff,
      ({ field, diffLength, newDiff }) => {
        if (diffLength !== 2) {
          return;
        }
        const parentField = diff.path[0];
        if (parentField !== HOME_SCREEN_PERMISSIONS_FIELD) {
          return;
        }
        if (field in CustomersFieldLabels && isNaN(Number(field))) {
          reports.push(newDiff);
        }
      },
      returnLabel
    )
  );
  return orderArray(reports, CustomersFieldLabels);
};
var generateWebHomeScreenArray = (diffArray, state) => {
  const reports = [];
  const originalData = selectCurrentSettingsOriginalData(
    state
  );
  const changeData = selectCurrentSettingsData(state);
  const dashboards = selectDashboards(state);
  diffArray.forEach(
    (diff) => filterDiffFunction(
      diff,
      ({ field, diffLength, newDiff }) => {
        var _a;
        if (diffLength !== 1 || field === "dashboardIds") {
          return;
        }
        if (field === "defaultDashboardId") {
          return reports.push(__spreadProps(__spreadValues({}, newDiff), {
            textValue: ((_a = dashboards[Number(newDiff.value)]) == null ? void 0 : _a.name) || i18n_config_default.t(
              "app.modals.rolesDiffModal.webHomeScreen.noDefaultDashboardId"
            )
          }));
        }
        if (field in WebHomeScreenFieldLabels && isNaN(Number(field))) {
          reports.push(newDiff);
        }
      },
      returnLabel
    )
  );
  const dashboardsDiff = getArrayNumberChanges(
    originalData.dashboardIds,
    changeData.dashboardIds
  );
  if (dashboardsDiff.length > 0) {
    reports.push({
      field: "dashboardIds",
      label: returnLabel("dashboardIds") || "",
      value: dashboardsDiff.map((diff) => __spreadProps(__spreadValues({}, diff), {
        value: dashboards[diff.id].name
      }))
    });
  }
  return orderArray(reports, CustomersFieldLabels);
};

export { diffRolesFactory };
